import {GeofenceEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Box, Modal, ModalProps} from "@mantine/core";
import {MouseEvent, useCallback} from "react";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {BaseGeofenceDataTable, BaseGeofenceDataTableProps} from "./BaseGeofenceDataTable";
import {useGeofenceAction} from "../../menu/GeofenceActionMenu/useGeofenceAction";

export type GeofenceDataTableProps = Omit<BaseGeofenceDataTableProps, 'renderActions'>

export const GeofenceDataTable = (props: GeofenceDataTableProps) => {
  const {
    ...rest
  } = props

  const {
    onGeofenceActionClick
  } = useGeofenceAction()

  const onEditActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: GeofenceEntity) => {
    e.stopPropagation()
    onGeofenceActionClick(record, 'EDIT')
  }, [onGeofenceActionClick])

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: GeofenceEntity) => {
    e.stopPropagation()
    onGeofenceActionClick(record, 'DELETE')
  }, [onGeofenceActionClick])

  const renderActions = useCallback((record: GeofenceEntity, index: number) => {
    return (
      <EntityActionGroup
        entity={record}
        permissionPrefix={"geofence"}
        view={false}
        onEditActionClick={(e) => onEditActionClick(e, record)}
        onDeleteActionClick={(e) => onDeleteActionClick(e, record)}
      />
    )
  }, [onEditActionClick, onDeleteActionClick])

  return (
    <BaseGeofenceDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}

export type GeofenceDataTableModalProps = Omit<ModalProps, "onSubmit"> & {
  dataTable: Omit<GeofenceDataTableProps, 'recordsPerPageOptions'>
}

export const GeofenceDataTableModal = (props: GeofenceDataTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.entity.geofence.plural", "Geofences"),
    dataTable,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <GeofenceDataTable
          {...dataTable}
          recordsPerPageOptions={[5]}/>
      </Box>
    </Modal>
  );
};
